import { useGetPresentersList } from '@/hooks';
import { PresenterUsecase } from '@d-id/types';

export const useGetPresenterByID = (id?: string, usecase: PresenterUsecase = PresenterUsecase.Video) => {
    const { data: presenters } = useGetPresentersList({ usecase });
    if (presenters && id) {
        return presenters.find(presenter => presenter.id === id);
    }
};
